import React__default from 'react';
import '../../utils/index.js';
import createContextUtilities from '../../utils/createContextUtilities/createContextUtilities.js';

function createContextValue(value) {
  return {
    className: value.className,
    inputClassName: value.inputClassName,
    applySmall: small => value.small || small,
    applyFull: full => {
      if (value.overrideFull) {
        return false;
      }
      return full;
    }
  };
}
const {
  Provider: InputGroupContextProvider,
  useContext: useInputGroupContext
} = createContextUtilities(createContextValue({}));
const InputGroupProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  const context = createContextValue(value);
  return /*#__PURE__*/React__default.createElement(InputGroupContextProvider, {
    value: context
  }, children);
};

export { InputGroupProvider, useInputGroupContext };
